import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose, setPropTypes, withHandlers } from 'recompose'
import withCommonImageGallery from './image-gallery'
import { getCharity } from '../charity/selectors'
import { createCharityImage, removeCharityImage } from '../charity/actions'
import ImageGallery from '../../../ui/forms/image-gallery'

const mapState = (state, ownProps) => {
  const charity = getCharity(ownProps.charityId, state)
  return {
    images: charity.photo
      ? [
          {
            id: ownProps.charityId,
            source: charity.photo,
            thumb: charity.photo_thumb || '',
            description: charity.photo,
            type: 'image'
          }
        ]
      : []
  }
}

const mapActions = {
  createCharityImage,
  removeCharityImage
}

export const withCharityImageAndActions = connect(mapState, mapActions)

export const withGalleryProps = withHandlers({
  onImageUploaded: props => (file, dataUrl) => {
    return props.createCharityImage(props.charityId, file, dataUrl)
  },
  onImageRemoved: props => imageId => {
    return props.removeCharityImage(props.charityId)
  }
})

export const withCharityGallery = compose(
  setPropTypes({
    charityId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
      .isRequired
  }),
  withCharityImageAndActions,
  withGalleryProps,
  withCommonImageGallery
)

export default withCharityGallery(ImageGallery)



// WEBPACK FOOTER //
// ./src/services/mycharity/media/charity-image-gallery.js